import { render, staticRenderFns } from "./PrefixTitle.vue?vue&type=template&id=a82d6cae&scoped=true"
import script from "./PrefixTitle.vue?vue&type=script&lang=js"
export * from "./PrefixTitle.vue?vue&type=script&lang=js"
import style0 from "./PrefixTitle.vue?vue&type=style&index=0&id=a82d6cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82d6cae",
  null
  
)

export default component.exports